export default [
    'departments.*',
    'groups.*',
    'services.*',
    'project-types.*',
    'taxes.*',
    'working-pattern.*',
    'company-holidays.*',
    'deleted-items.*',
    'purchase-order-types.*',
];
